const TESTIMONIALS = [
  {
    name: 'Hiren Shah',
    role: 'Founder, B2B-Matrix Inc.',
    quote:
      'Partnering with Monkstack Solutions has been a total game-changer for is. They delivered a seamless MCP solution for our Salesforce application that completely transforms how we leverage data. If you want to scale your intelligent infrastructure with a team that truly gets it, Monkstack is the partner you need.',
    image: '/img/testimonials/hiren-shah.jpeg',
  },
  {
    name: 'Dr.Meghana Ghanawat',
    role: 'Founder, Bharat Aeromedical Retrieval Services',
    quote:
      'Monkstack Solutions engineers end-to-end technical transformations, moving your business from legacy bottlenecks to intelligent, cloud-native architectures.',
    image: '/img/testimonials/meghana-ghanawat.jpeg',
  },
  {
    name: 'Anonymous',
    role: 'Founder, Manufacturing Company',
    quote:
      'We transform traditional shop floors into connected, autonomous plants by overhauling legacy systems into unified, intelligent operational engines.',
    image: '/img/testimonials/erp.png',
  },
  {
    name: 'Shaye',
    role: 'COO, Eaxora',
    quote:
      'Monkstack Solutions transforms standard e-commerce into an intelligent, conversational storefront by re-engineering your core search and data layer from the ground up.',
    image: '/img/testimonials/eaxora.png',
  },
  {
    name: 'Mayank',
    role: 'Founder, mamsampark',
    quote:
      'We transformed high-volume spoken voice into structured business intelligence by engineering a low-latency, real-time AI streaming pipeline.',
    image: '/img/testimonials/mamsampark.png',
  }
]

export default TESTIMONIALS;
